import React from "react";
import ReactMoment from "react-moment";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";
import Pagination from "../../../../../../Components/Pagination/QSP";
import { graphqlUri } from "../../../../../../Config/Env";

export default ({
  history,
  match,
  location,
  config,
  page,
  keyword,
  keywordInput,
  blockSize,
  first,
  data,
  loading,
  baseUrl,
  handleSearch,
}) => {
  return (
    <>
      <Helmet>
        <title>이벤트 관리 | 한밭페이 </title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">이벤트</li>
        </ol>
        <h1 className="page-header">이벤트</h1>
        <div className="row">
          <div className="col-xl-12">
            {loading && (
              <div className="panel-loader">
                <span className="spinner-small"></span>
              </div>
            )}

            <Panel>
              <PanelHeader noButton={true}>
                목록({!loading && data.AdminEventList.count}건)
              </PanelHeader>
              <Alert className="bg-gray-transparent-1">
                <div className="row">
                  <div className="col-xs-12">
                    <form onSubmit={handleSearch}>
                      <InputGroup>
                        <Input
                          type="text"
                          className="input-white"
                          placeholder="검색어(이름) 입력"
                          value={keywordInput.value}
                          onChange={keywordInput.onChange}
                        />
                        <InputGroupAddon addonType="append">
                          <Button size="sm" color="white">
                            <i className="fa fa-search fa-fw"></i>
                          </Button>
                          <Link
                            to={`/eventConfigs/${match.params.CommonApp}/${config.AdminEventConfig.id}/edit${location.search}`}
                            className="btn btn-white"
                          >
                            <i className="fa fa-cog fa-fw"></i>
                          </Link>
                        </InputGroupAddon>
                      </InputGroup>
                    </form>
                  </div>
                </div>
              </Alert>
              {!loading && data.AdminEventList.count > 0 ? (
                <>
                  <PanelBody>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped m-b-0">
                        <colgroup>
                          <col width="15%" />
                          <col width="*" />
                          <col width="15%" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>이미지</th>
                            <th>정보</th>
                            <th>작성일</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.AdminEventList.events.map((item) => {
                            const eventCoverImg =
                              item.coverImg === ""
                                ? "/assets/img/gallery/gallery-default.jpg"
                                : `${graphqlUri}${item.coverImg}`;
                            const date = new Date();
                            const startDate = new Date(item.startDate);
                            const endDate = new Date(item.endDate);

                            return (
                              <tr key={item.id}>
                                <td>
                                  <div
                                    className="product-img"
                                    style={{
                                      backgroundImage: `url(${eventCoverImg})`,
                                    }}
                                  >
                                    <img src={eventCoverImg} alt={item.name} />
                                  </div>
                                </td>
                                <td className="valign-middle">
                                  <div>
                                    <Link
                                      to={`/eventConfigs/${match.params.CommonApp}/${config.AdminEventConfig.id}/events/${item.id}${location.search}`}
                                    >
                                      <h4 className="widget-list-title m-t-5">
                                        {item.title}
                                      </h4>
                                      <h5 className="widget-list-title m-t-5">
                                        {item.commonStatus === "S" && "비공개"}
                                        {item.commonStatus === "C" &&
                                        date >= startDate &&
                                        date <= endDate
                                          ? "진행"
                                          : "종료"}
                                      </h5>
                                      <ReactMoment format="YYYY-MM-DD">
                                        {item.startDate}
                                      </ReactMoment>
                                      ~
                                      <ReactMoment format="YYYY-MM-DD">
                                        {item.endDate}
                                      </ReactMoment>
                                    </Link>
                                  </div>
                                </td>
                                <td className="text-nowrap text-center valign-middle">
                                  <div className="btn-group-vertical">
                                    {/* <Link to="" className="btn btn-white">
                                      <i class="fa fa-arrow-up"></i>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn btn-white"
                                    >
                                      <i className="fa fa-arrow-down"></i>
                                    </button> */}
                                    <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                                      {item.createdAt}
                                    </ReactMoment>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </PanelBody>
                  <PanelFooter>
                    <div className="row">
                      <div className="col-md-6">
                        <Pagination
                          totalRecord={data.AdminEventList.count}
                          blockSize={blockSize}
                          pageSize={first}
                          currentPage={page}
                          baseUrl={baseUrl}
                        />
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </PanelFooter>
                </>
              ) : (
                <PanelBody>
                  <p className="text-center">등록된 데이터가 없습니다.</p>
                </PanelBody>
              )}
            </Panel>
          </div>
        </div>
      </div>
      <Link
        to={`/eventConfigs/${match.params.CommonApp}/${config.AdminEventConfig.id}/events/write${location.search}`}
        className="btn btn-icon btn-circle btn-lg btn-primary btn-scroll-to-top"
      >
        <i className="fas fa-pencil-alt"></i>
      </Link>
    </>
  );
};
